import { Component, computed, PLATFORM_ID, inject, input, OnInit, signal } from '@angular/core';
import { MyPurchasesPageComponent } from './my-purchases-page/my-purchases-page.component';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { SelectModule } from 'primeng/select';
import { PaginatorModule } from 'primeng/paginator';
import { FormsModule } from '@angular/forms';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MyPurchasesService } from '../../../services/bidder-community/my-purchases/my-purchases.service';
import { AuthService } from '../../../services/authentication/auth.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-my-purchases',
  imports: [MyPurchasesPageComponent,
    SelectModule,
    PaginatorModule,
    FormsModule,
    ProgressSpinnerModule,
    CommonModule
  ],
  templateUrl: './my-purchases.component.html',
  styleUrl: './my-purchases.component.scss'
})
export class MyPurchasesComponent implements OnInit {

  private readonly bidderCommunityMenuService = inject(BidderCommunityMenuService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly myPurchasesService = inject(MyPurchasesService);
  private readonly authService = inject(AuthService)
  private readonly platformId = inject(PLATFORM_ID);


  authSubscription!: Subscription;
  isAuthenticated = this.oidcSecurityService.authenticated;
  isLoading = this.myPurchasesService.isLoading;


  public id = input(0);

  myPurchases = this.myPurchasesService.myPurchasesSignal;

  myPurchasesResponse = computed(() => this.myPurchasesService.myPurchasesSignal());
  purchases = computed(() => this.myPurchases()?.purchases);
  totalPurchases = computed(() => this.myPurchases()?.totalPurchases);


  // paginator
  page: number = 0;
  rowsPerPageOptions = [6, 10, 18, 25];
  first = signal(0);
  rows = signal(6);

  selectedSortSignal = signal('CREATED_DESC');

  sortFilters = [
    { label: 'Card - Ascending', value: 'CARD_ASC' },
    { label: 'Card - Descending', value: 'CARD_DESC' },
    { label: 'Status - Ascending', value: 'STATUS_ASC' },
    { label: 'Status - Descending', value: 'STATUS_DESC' },
    { label: 'Created Date - Ascending', value: 'CREATED_ASC' },
    { label: 'Created Date - Descending', value: 'CREATED_DESC' },
    { label: 'Modified Date - Ascending', value: 'MODIFIED_ASC' },
    { label: 'Modified Date - Descending', value: 'MODIFIED_DESC' },
    { label: 'Total - Ascending', value: 'TOTAL_ASC' },
    { label: 'Total - Descending', value: 'TOTAL_DESC' },
    { label: 'Organization Name - Ascending', value: 'ORG_NAME_ASC' },
    { label: 'Organization Name - Descending', value: 'ORG_NAME_DESC' }
  ];

  filters = signal({
    sort: this.selectedSortSignal(),
    page: 1,
    per: 6
  });



  ngOnInit(): void {
    setTimeout(() => {
      this.bidderCommunityMenuService.setPageData(
        {
          id: 341706533,
          pageName: "My Purchases",
          pageRoute: "my-purchases"
        }
      );

      if (typeof window !== 'undefined') {
        window.onpageshow = function (event) {
          if (event.persisted) {
            window.location.reload();
          }
        };
      }

      if (this.isAuthenticated().isAuthenticated) {
        this.getMyPurchases();
      } else {
        if (typeof window !== 'undefined') {
          window.open(environment.mediaUrl, '_self');
        }
        return;
      }

      this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
        if (isAuth) {
          this.getMyPurchases();
        } else {
          if (isPlatformBrowser(this.platformId)) {
            if (typeof window !== 'undefined') {
              window.open(environment.mediaUrl, '_self');
            }
          }
        }
      });
    },100);

  }

  onSortChange(event: any): void {
    const sortValue = event.value;

    this.selectedSortSignal.set(sortValue);
    this.filters.update(filters => ({
      ...filters,
      sort: sortValue,
      page: 1
    }));

    this.myPurchasesService.getMyPurchases(this.filters()).subscribe();
  }

  onPageChange(event: any) {
    this.filters.update(filters => ({
      ...filters,
      page: event.page + 1,
      per: event.rows
    }));

    this.myPurchasesService.getMyPurchases(this.filters()).subscribe();
  }

  getMyPurchases() {

    this.myPurchasesService.getMyPurchases(this.filters()).subscribe({
      next: (response) => {
        // console.log('My purchases', response);
      },
      error: (err) => {
        console.error('Error my purchases:', err.message);
      }
    });

  }

}
